import * as _ from 'lodash';

import { Miniature, ContextualField, PropertyType, Shape, ShapePoint } from '../../models';
import { infoTextColor } from '../../common/constants';
import { IWidget } from '../../widgets';
import { Helper } from '../../common/helpers';

export const shapeControllerCommon = {
    miniatures: [
        new Miniature('shape', 'Shape', 'fa-line-chart', ['A new shape', 'With fixed points or bound to data'])
    ],

    getFields: (getSelected: () => Shape, getShapes: () => Shape[]): ContextualField[] => {
        return [
            {
                label: 'Name',
                modelName: 'name',
                propertyName: 'name',
                propertyType: PropertyType.Text,
                required: true,
                isValid: modelValue => Helper.getDictionnary<boolean>([
                    { key: 'duplicate', value: !_.some(getShapes(), s => s.name === modelValue && s.guid !== getSelected().guid) }
                ]),
                icon: 'fa-id-badge',
                messages: [
                    { key: 'duplicate', value: 'A shape with this name already exists' },
                    { key: 'required', value: 'A name is required' }
                ]
            }, {
                label: 'Aggregation mode',
                modelName: 'aggregationMode',
                propertyName: 'aggregationMode',
                propertyType: PropertyType.AggregationMode,
                icon: 'fa-calculator'
            }, {
                label: 'Color',
                modelName: 'color',
                propertyName: 'color',
                propertyType: PropertyType.Color,
                icon: 'fa-square',
                extraData: {
                    position: 'left'
                }
            }, {
                label: 'Symbol',
                modelName: 'symbol',
                propertyName: 'symbol',
                propertyType: PropertyType.Symbol,
                extraData: {
                    showName: true,
                    disableWithNone: 'isSymbolVisible'
                },
                isValid: value => Helper.getDictionnary<boolean>([
                    { key: 'required', value: !getSelected().isSymbolVisible || !!value }
                ]),
                icon: 'fa-circle'
            }, {
                label: 'Show line',
                modelName: 'isLineVisible',
                propertyName: 'isLineVisible',
                propertyType: PropertyType.Boolean,
                icon: 'fa-line-chart'
            }, {
                label: 'Thickness',
                modelName: 'thickness',
                propertyName: 'thickness',
                propertyType: PropertyType.Number,
                extraData: {
                    decimals: 0
                },
                icon: 'fa-arrows-h'
            }, {
                label: 'Fill shape',
                modelName: 'isFilled',
                propertyName: 'isFilled',
                propertyType: PropertyType.Boolean,
                icon: 'fa-tint',
            }, {
                label: 'Interpolation mode',
                modelName: 'interpolation',
                propertyName: 'interpolation',
                propertyType: PropertyType.Interpolation,
                iconText: '∞'
            },
        ];
    },

    onDrop: (item: IWidget, select: (shape: Shape) => void): void => {
        let shapes = item.configuration.shapes;
        if (!shapes) {
            shapes = [];
        }
        const newshape = new Shape('', infoTextColor);
        const newShapes = shapes.concat([newshape]);
        item.configuration.shapes = newShapes;
        select(newshape);
    },

    addPoint: (selectedShape: Shape, canBind: boolean): void => {
        let points = selectedShape.points;
        if (!points) {
            points = [];
        }
        const newPoint = new ShapePoint();
        newPoint.x.isBoundToGroup = canBind;
        newPoint.y.isBoundToGroup = canBind;
        points.push(newPoint);
        selectedShape.points = points;
    }
};